import type { PlacesFormSort } from '../pages/private/Discover/types/placesSearch.types';
import type { PlaceFilters } from '../types/place.types';
import { PLACE_FILTERS_INITIAL_VALUES, normalizePlaceFilters } from '../types/place.types';
import { placeFormSortToOrderingParam } from '../pages/private/Discover/utils/placesSearch.utils';

export function buildPlaceSearchParams(
  page: number,
  searchFilters?: PlaceFilters,
  sortBy?: PlacesFormSort
): Record<string, string | number> {
  const params: Record<string, string | number> = {};

  if (sortBy) {
    params.ordering = placeFormSortToOrderingParam(sortBy);
  }

  const normalizedFilters = normalizePlaceFilters(searchFilters ?? PLACE_FILTERS_INITIAL_VALUES);

  if (normalizedFilters.petFriendly) {
    params.pet_friendly = 'true';
  }

  if (normalizedFilters.goodForGroup) {
    params.good_for_group = 'true';
  }

  if (normalizedFilters.goodForChildren) {
    params.good_for_children = 'true';
  }

  if (normalizedFilters.ratings.length > 0) {
    params.stars = normalizedFilters.ratings.join(',');
  }

  if (page > 1) {
    params.page = page;
  }

  return params;
}

export function serializePlaceSearchParams(params: Record<string, string | number>): string {
  return Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join('&');
}

export function hasBackendPlaceFiltersChanged(prev: PlaceFilters, next: PlaceFilters): boolean {
  return (
    prev.ratings.join(',') !== next.ratings.join(',') ||
    prev.petFriendly !== next.petFriendly ||
    prev.goodForChildren !== next.goodForChildren ||
    prev.goodForGroup !== next.goodForGroup
  );
}
